// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2Nq3c","colMin":"styles_colMin__2-_6R","colCheckbox":"styles_colCheckbox__oBF2p"};